<div #rootModal
     class="modalBackground"
     [ngClass]="{'modalBackgroundVisible': activeModals.length !== 0}">

</div>
